import { APIModel } from '@shared/interfaces';

import { Action } from './action.enum';
import { Model } from './model.enum';

export const CORRECT_CODENAME_SPLIT_LENGTH = 2;

export class Permission implements APIModel {
    id = -1;
    codename = '';
    readableCodeName = '';
    model: Model = Model.Unknown;
    action: Action = Action.Unknown;

    deserialize(data: any): this {
        this.id = data.id;
        this.codename = data.codename;
        let codeNameSplit = data.codename.split('_');
        if (
            codeNameSplit.length === CORRECT_CODENAME_SPLIT_LENGTH &&
            Object.values(Model).includes(codeNameSplit[1]) &&
            Object.values(Action).includes(codeNameSplit[0])
        ) {
            this.model = codeNameSplit[1] as Model;
            this.action = codeNameSplit[0] as Action;
            this.readableCodeName = `${getLocalizedModelNames()[this.model] ?? codeNameSplit[1]}: ${
                getLocalizedModelPermissions()[this.action] ?? codeNameSplit[0]
            }`;
        } else {
            this.readableCodeName = data.codename;
        }

        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            codename: this.codename,
        };
    }
}

function getLocalizedModelNames(): Record<Model, string> {
    return {
        annualreportprompt: $localize`:@@model.annualReportPrompt:Cijferanalyse-instructies`,
        bulkimport: $localize`:@@model.bulkImports:Bulk-imports`,
        customerssupplierssettings: $localize`:@@model.customersSuppliersSettings:Klanten- en leveranciersinstellingen`,
        depreciationsettings: $localize`:@@model.depreciationSettings:Afschrijvingsinstellingen`,
        personaltaxsettings: $localize`:@@model.personalTaxSettings:Vragenlijstinstellingen`,
        questionnairetemplate: $localize`:@@model.questionnaireTemplate:Vragenlijstsjablonen`,
        connection: $localize`:@@model.connection:Verbindingen`,
        companyaccess: $localize`:@@model.companyAccess:Dossiertoegang`,
        invitation: $localize`:@@model.invitation:Uitnodigingen`,
        member: $localize`:@@model.member:Leden`,
        organisation: $localize`:@@model.organisation:Organisaties`,
        organisationrole: $localize`:@@model.organisationRoles:Organisatierollen`,
        organisationstatistics: $localize`:@@model.organisationStatistics:Organisatiestatistieken`,
        organisationquestion: $localize`:@@model.organisationQuestion:Organisatievragen`,
        organisationhistory: $localize`:@@model.usage:Organisatiegebruik`,
        personaltaxsync: $localize`:@@model.personalTaxSync:Dossiersynchronisatie`,
        ragfile: $localize`:@@model.ragFile:Chatbotbestanden`,
        subscription: $localize`:@@model.subscriptions:Apps`,
        genericscenario: $localize`:@@model.scenarios:Algemene scenario's`,
        exportfilemerge: $localize`:@@model.exportFileMerge:XBRL samenvoegingen`,
        waitinglistentry: $localize`:@@model.waitingListEntry:Items in de VZW wachtrij`,
        unknown: $localize`:@@model.unknown:Onbekend`,
        sharepointsite: $localize`:@@model.settings:Chatbotinstellingen`,
        vatimportsettings: $localize`:@@model.vatImportSettings:BTW-importinstellingen`,

    };
}


function getLocalizedModelPermissions(): Record<Action, string> {
    return {
        add: $localize`:@@model.permission.add:toevoegen`,
        change: $localize`:@@model.permission.change:wijzigen`,
        delete: $localize`:@@model.permission.delete:verwijderen`,
        view: $localize`:@@model.permission.view:bekijken`,
        unknown: $localize`:@@model.permission.unknown:onbekend`,
    };
}
